export default __webpack_public_path__ + "static/media/crossroads10.a0ab08e5.webp";